import { c as _c } from "react/compiler-runtime";
import { InterfaceChainUtils } from '@morpho-org/dapp-core';
import { useCallback } from 'react';
import { useWeb3Context } from '@/contexts/Web3Context';
import { useGenerateUrl } from '@/hooks/useGenerateUrl';
interface UseChainNavigationInput {
  chainId: number;
}

/**
 * Hook for synchronizing chain state and URL when chain ID changes.
 * Route-aware: on multi-chain pages, only sets target chain without URL manipulation.
 */
export const useChainNavigation = t0 => {
  const $ = _c(9);
  const {
    chainId
  } = t0;
  const {
    targetChain: currentChain,
    onSetTargetChain,
    isMultiChainPage
  } = useWeb3Context();
  const generateUrl = useGenerateUrl();
  let t1;
  if ($[0] !== chainId || $[1] !== currentChain.id || $[2] !== generateUrl || $[3] !== isMultiChainPage || $[4] !== onSetTargetChain) {
    t1 = () => {
      if (currentChain.id !== chainId) {
        const chainMetadata = InterfaceChainUtils.getMetadata(chainId);
        onSetTargetChain(chainMetadata.chain);
        if (isMultiChainPage) {
          return;
        }
        const url = generateUrl({
          chainIdentifier: chainMetadata.chainIdentifier
        });
        const current = window.location.pathname + window.location.search;
        if (current !== url) {
          window.history.pushState({
            ...window.history.state,
            as: url,
            url
          }, "", url);
        }
      }
    };
    $[0] = chainId;
    $[1] = currentChain.id;
    $[2] = generateUrl;
    $[3] = isMultiChainPage;
    $[4] = onSetTargetChain;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const syncChainSwitch = t1;
  const t2 = currentChain.id === chainId;
  let t3;
  if ($[6] !== syncChainSwitch || $[7] !== t2) {
    t3 = {
      syncChainSwitch,
      isCurrentChain: t2
    };
    $[6] = syncChainSwitch;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};